import React, {useCallback} from 'react';
import {Trans, useTranslation} from 'react-i18next';

import {DetailValue} from './types';

const useFormatDetails = (): ((detail: DetailValue) => JSX.Element) => {
    const {t} = useTranslation(['activation']);

    return useCallback(
        detail => {
            const {label} = detail;
            const value = Array.isArray(detail.value) ? detail.value.join('\n') : detail.value;
            return (
                <div
                    className="col-6 p-2"
                    key={detail.label}
                    style={{wordBreak: 'break-word', boxSizing: 'border-box', whiteSpace: 'pre-line'}}
                >
                    <Trans
                        i18nKey="activation:labelValue"
                        t={t}
                    >
                        <strong className="overline-regular">{{label}}</strong>
                        <p>{{value}}</p>
                    </Trans>
                </div>
            );
        },
        [t]
    );
};

export {useFormatDetails};
